import { ProductUIAppWindow } from 'components/product-ui/product-ui-app-window/product-ui-app-window';
import { ProductUITaskAttributePill } from 'components/product-ui/product-ui-task-attribute-pill/product-ui-task-attribute-pill';
import { QuickAdd, QuickAddAttributeContainer } from 'components/product-ui/quick-add/quick-add';
import { useTranslation } from 'next-i18next';
import { ProductUIButton } from '../product-ui-button/product-ui-button';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { TemplateSidebarStandard } from '../product-ui-sidebar/product-ui-sidebar-templates';
import { TemplateTodayView } from '../product-ui-view/product-ui-view-templates';
function QuickAddScene() {
  const {
    t
  } = useTranslation('productui');
  return <ProductUISceneContainer backgroundVariant="wave-two" data-sentry-element="ProductUISceneContainer" data-sentry-component="QuickAddScene" data-sentry-source-file="quick-add.tsx">
            <ProductUISceneLayer position="modalOpenLeft" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="quick-add.tsx">
                <ProductUIAppWindow sidebar={<TemplateSidebarStandard />} view={<TemplateTodayView />} inlineSize={808} blockSize="calc(100% + 7px)" showOverlay data-sentry-element="ProductUIAppWindow" data-sentry-source-file="quick-add.tsx" />
            </ProductUISceneLayer>
            <ProductUISceneLayer position="center" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="quick-add.tsx">
                <QuickAdd taskSection={<QuickAdd.TaskText>
                            <QuickAdd.Intent>{t('sequence.quickadd.callAlex')}</QuickAdd.Intent>
                            <QuickAdd.Intent variant="highlight">
                                {t('sequence.quickadd.wedAt10am')}
                            </QuickAdd.Intent>
                        </QuickAdd.TaskText>} attributeSection={<QuickAddAttributeContainer>
                            <ProductUITaskAttributePill variant="dueDateCustom" color="purple">
                                {t('sequence.quickadd.wed10am')}
                            </ProductUITaskAttributePill>
                        </QuickAddAttributeContainer>} footerSection={<QuickAdd.FooterContainer>
                            <QuickAdd.FooterProjectButton />
                            <QuickAdd.FooterSpacer />
                            <ProductUIButton className="addTaskButton" variant="primary">
                                {t('quickAdd.addTask')}
                            </ProductUIButton>
                        </QuickAdd.FooterContainer>} data-sentry-element="QuickAdd" data-sentry-source-file="quick-add.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}
export { QuickAddScene };